import React, { Component } from "react";
import { connect } from "react-redux";
import { NavLink } from "react-router-dom";
import MyOffers from "../components/my-offers/MyOffers";
import SummaryPayment from "../components/my-offers/SummaryPayment";
import MarketAnalysis from "../components/market-analysis/MarketAnalysis";
import ViewOffer from "../components/my-offers/ViewOffer";
import { getUserToken } from "../shared/utils";
import { receiveOffers, isNewUser } from "../actions";
import NoOffers from "../components/my-offers/NoOffers";
import CreateOffer from "./CreateOffer";
import { getExtractResale } from "./../shared/requests-api";
import jwt_decode from "jwt-decode";
import { FamilyAccountBanner } from "../../shared/FamilyAccountBanner/FamilyAccountBanner";

class Home extends Component {
	constructor() {
		super();
		this.state = {};
	}

	renderView() {
		const { offer, sending, showSendModal, viewMode } = this.props;

		if (this.state.extracts) {
			return (
				<div>
					<MyOffers />
				</div>
			);
		}

		switch (viewMode) {
			case "edit":
				return <CreateOffer offer={offer} acronym={offer.fidelity.airlineAcronym} />;
			case "new":
				return <NoOffers />;
			default:
				return (
					<div>
						<MyOffers />
					</div>
				);
		}
	}

	renderMarketAnalysis() {
		const { offer, sending, showSendModal, viewMode } = this.props;

		if (viewMode == "edit") {
			return null;
		}
		return <MarketAnalysis />;
	}

	componentDidMount() {
		const token = getUserToken();
		const payload = jwt_decode(token);

		getExtractResale(payload.username)
			.then(response => {
				this.setState({ extracts: response.data.resealeCharge.extracts });
			})
			.catch(error => console.error(error));
	}

	render() {
		return (
			<div className="offers-home row">
				<FamilyAccountBanner contentType="banner-conta-familia-minhas-ofertas"/>
				<div className="col-xs-16 col-md-13">{this.renderView()}</div>

				<div className="hidden-xs col-sm-16 col-md-3 text-center market-analysis-div">
					{this.renderMarketAnalysis()}
				</div>
			</div>
		);
	}
}

const mapStateToProps = state => ({
	reload: state.offers.reload,
	newUser: state.offers.newUser,
	viewMode: state.offers.viewMode,
	offer: state.offers.offer,
	sending: state.offers.sending,
	showSendModal: state.offers.showSendModal
});

const mapDispatchToProps = dispatch => {
	return {
		isReloadOffers: offers => dispatch(isReloadOffers(offers)),
		receiveOffers: offers => dispatch(receiveOffers(offers)),
		isNewUser: newUser => dispatch(isNewUser(newUser))
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(Home);
